import {BasePqForm} from "biz-ts/src/api/Paging";

export class FlistForm {
    productId?: number

    constructor(productId: number) {
        this.productId = productId;
    }
}

export class FavailablesForm {
    productId?: number

    constructor(productId: number) {
        this.productId = productId;
    }
}

export class FpqForm extends BasePqForm {
    productId?: number

    constructor(productId: number) {
        super();
        this.productId = productId;
    }
}

export class FcreateForm {
    productId?: number
    file?: File = undefined
    version?: string = undefined
    name?: string = undefined
    description?: string = undefined
    remark?: string = undefined

    constructor(productId: number) {
        this.init(productId)
    }

    init(productId: number): void {
        this.productId = productId
        this.file = undefined
        this.version = undefined
        this.name = undefined
    }
}
